import { Box, Heading } from '@hover/blueprint';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { ArrowButton } from '@hover/shared-components';

const Footer = () => (
  <Box
    w="100%"
    bg="brandNavy.500"
    display="flex"
    flexDir="column"
    justifyContent="center"
    alignItems="center"
    pb="88px"
    pt="187px"
    mt="170px"
    position="relative"
    px={500}
  >
    <Box
      style={{
        position: 'absolute',
        margin: 'auto',
        left: 0,
        right: 0,
        top: '-167px',
        textAlign: 'center',
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      maxW="236px"
      maxH="297px"
    >
      <StaticImage
        placeholder="blurred"
        objectFit="contain"
        src="../../assets/images/news_footer.png"
        alt="SOC logo service organization"
        style={{
          borderRadius: '30% 30% 0 0',
          border: '4px white solid',
        }}
      />
    </Box>
    <Heading
      as="h2"
      size={{ base: 500, tablet: 600, desktop: 700 }}
      marginBottom="0px!important"
      pb={700}
      color="neutral.0"
      alignSelf="center"
    >
      For media queries
    </Heading>
    <ArrowButton
      as={Link}
      to="/contact/"
      variant="inverted"
      colorScheme="brandNavy"
      w={{ base: '323px', tablet: 'auto' }}
    >
      Contact us
    </ArrowButton>
  </Box>
);

export default Footer;
